export default function AuthFooter() {
  return (
    <footer className="bg-primary text-center text-white py-2">
      <div className="container">© 2026 Foresight Elusa Health All rights reserved</div>
    </footer>
  );
}
